export default "__VITE_ASSET__DUDVLbUL__"